<template>
    <div>
        <template v-if="lang==1">
            <p class="pre_">
                尊敬的客户，感谢您选择中银保险有限公司！
                本产品由中银保险有限公司上海分公司承保，由安联世合国际救援服务（北京）有限公司提供救援服务。
            </p>
            <p>
                <img class="height-pc-mar" src="../../../../assets/astp/8.jpg">
                <img class="height-pc" src="../../../../assets/astp/9.jpg">
            </p>
            <h4>投保前请仔细阅读以下须知：</h4>
            <p class="pre_">
                1.请注意对于被保险人不满10周岁的，身故（包含意外身故、急性病身故）给付的保险金额总和不得超过人民币20万元；对于被保险人已满10周岁不满18周岁的，身故（包含意外身故、急性病身故）给付的保险金额总和不得超过人民币50万元。
                2.本保险保障您（被保险人）因遭受意外伤害事故或罹患突发性疾病导致的医疗费用报销以及紧急医疗转运和送返。具体保障项目以条款为准。
                3.年龄限制在出生满为60天-80周岁（含60天和80周岁）。拥有中国国籍的公民，或在中国境内拥有居留证或长期居住权或持有中华人民共和国政府部门签发的工作签证的非中国国籍居民，身体健康，出境旅游、探亲访友、继承遗产以及从事商务活动或公务活动（不包括出国劳务或就业）的自然人均可作为本合同的被保险人。
                4.在同一保险期间内，每位被保险人仅限投保一份旅行保险。超出部分无效。
                5.医疗送返的目的地为您在中国大陆的居住地。
                6.除外国家和地区：（1）中国大陆、美国、加拿大、墨西哥；（2）阿富汗、亚美尼亚、阿塞拜疆、白俄罗斯、缅甸、布隆迪、中非共和国、古巴、刚果共和国、埃及、厄立特里亚、几内亚、几内亚比绍共和国、海地、伊朗、伊拉克、黎巴嫩、利比亚、马里、尼加拉瓜、朝鲜、俄罗斯、索马里、南苏丹、苏丹、叙利亚、突尼斯、乌克兰、委内瑞拉、波黑、黑山、塞尔维亚、也门、津巴布韦等依据联合国或欧盟、中华人民共和国或美国的贸易或经济制裁措施、法律或法规，导致我们履行保险本合同可能遭受任何制裁、禁令或限制令的国家或地区；（3）救援公司无法提供服务的国家或地区。
                7.每次承保旅程最长期限为90天
                8.本保险不承保既往病症

                温馨提示
                1. 本保单以中英文制作，一旦发生任何分歧，以中文文本为准。
                2. 理赔电话: 400-650-8012
                3. <span class="highlight_">安联旅行24小时紧急救援电话：</span>(+8610)8535-5960
                4. 请登陆中银保险官方网站https://e.bocins.com查询保单、条款信息。
                5. 如对保险合同条款有任何疑问，请致电客户服务咨询电话： 400-650-0269
            </p>
        </template>
        <template v-else>
            <p class="pre_">
                Dear customers, thank you for choosing BOC Insurance Co., Ltd!
                The product is underwritten by BOC Insurance Shanghai Branch and services are provided by Allianz Partners International Assistance Services (Beijing) Co., Ltd.
            </p>
            <p>
                <img class="height-pc-mar" src="../../../../assets/astp/8.jpg">
                <img class="height-pc" src="../../../../assets/astp/9.jpg">
            </p>
            <h4>Please read the following instructions carefully before applying for insurance:</h4>
            <p class="pre_">
                1.Please note for the insured who is under 10 years old, amount of Death (including Accidental
                Death/Death due to Acute Disease) should not exceed 200K; For the insured who is Between 10 to 18 years
                old, amount of Death (including Accidental Death and Death due to Acute Disease) should not exceed 500K.
                2.This policy covers benefits of Medical Reimbursement and Emergency Medical Evacuation & Repatriation
                caused by that the Insured encounters injury accident orsudden disease. Please refer to the policy
                wording for detail.
                3.Age limitation is 60 Days-80 years old(including full 60 days and 80). Citizens with Chinese
                nationality, or non Chinese residents with residence permit or long-term residence right in China or
                with work visa issued by the government departments of the people's Republic of China, natural persons
                who are in good health, travel abroad, visit relatives and friends, inherit heritage and engage in
                business or official activities (excluding overseas labor or employment)can be insured under this
                contract.
                4.In one single trip duration, no more than one policy is granted to each insured. Any extra policy
                shall be invalid.
                5.The destination of repatriation is your resident city in Mainland China.
                6.Excluded countries and regions: (1) China(Mainland), United States, Canada, Mexico; (2) Afghanistan,
                Armenia, Azerbaijan, Belarus, Burma (Myanmar), Burundi, Central African Republic, Cuba, Democratic
                Republic Congo, Egypt, Eritrea, Guinea, Guinea-Bissau, Haiti, Iran, Iraq, Lebanon, Libya, Mali,
                Nicaragua, North Korea, Russia, Somalia, South Sudan, Sudan (North) , Syria, Tunisia, Ukraine,
                Venezuela, Western Balkans(Bosnia & Herzegovina, Montenegro, Serbia), Yemen, Zimbabwe, and any other
                countries or regions related to which the performance of this contract would expose us to any sanction,
                prohibition or restriction under United Nations resolutions or the trade or economic sanctions, laws or
                regulations of the European Union, People’s Republic of China or United States of America; (3) where the
                Assistance companies cannot provide services.
                7.The limit of insurance duration is 90 days per trip.
                8.Non-coverage of pre-existing medical conditions.

                Warm Tips：
                1. This policy is written in both Chinese and English. Should there be any discrepancy between the two
                language version，the Chinese version shall prevail.
                2. Claim Service：400-650-8012
                3. <span class="highlight_">Assistance Hotline: Allianz Partners International Assistance Services
                    (Beijing) Co.,Ltd.
                    Call No.：</span>(+8610)8535-5960
                4. Please visit the BOCI website https://e.bocins.com to enquiry policy, policy wording information.
                5. Customer Service Hotline : 400-650-0269
            </p>
        </template>
    </div>
</template>
<style lang="scss" scoped>
    /* 移动端  */
    @media all and (max-width: 768px) {
        img {
            width: 100%;
        }
    }

    /* PC端 */
    @media all and (min-width: 769px) {
        .height-pc {
            height: 427px;
        }

        .height-pc-mar {
            margin-right: 100px;
        }
    }

    .highlight_ {
        color: #FF3E18;
        font-weight: bold;
    }
</style>
<script>
    export default {
        props: {
            lang: {
                type: Number,
                default: 1
            }
        }
    }
</script>